import { render, staticRenderFns } from "./ModalSolicitacaoCirurgiaMedicoDataAgendamento.vue?vue&type=template&id=6d7fc685&scoped=true"
import script from "./ModalSolicitacaoCirurgiaMedicoDataAgendamento.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCirurgiaMedicoDataAgendamento.vue?vue&type=script&lang=ts"
import style0 from "./ModalSolicitacaoCirurgiaMedicoDataAgendamento.vue?vue&type=style&index=0&id=6d7fc685&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7fc685",
  null
  
)

export default component.exports